import {
  SET_SHOP_COUNTERS, RECALCULATE_ARRANGEMENTS_COUNT, RECALCULATE_LESSONS_COUNT,
  RECALCULATE_MODERATOR_ARRANGEMENTS_COUNT, RECALCULATE_MODERATOR_LESSONS_COUNT,
  SET_SHOP_TAGS, SET_SHOP_COMPOSERS, SET_SHOP_PERFORMERS, SET_SHOP_FILMS,
  SET_SHOP_DIFFICULTIES, SET_SHOP_TONALITIES,
  SET_OFFERS_FORM_INFO,
  SET_OFFERS_LIST,
  SET_MODER_OFFERS_LIST,
  REMOVE_OFFER,
  CREATE_OFFER,
  SET_OFFER_FOR_UPDATE, SET_UPDATED_FILES,
  CLEAR_INITIAL_VALUES, CLEAR_UPDATED_FILES, CLEAR_HIDE_DELETE_FILES_ACTIONS, SET_HIDE_DELETE_FILES_ACTIONS,
  UPDATE_OFFER, UPDATE_OFFER_PARTIAL, UPDATE_MODERATOR_OFFER_PARTIAL
} from '../constants/shop';
import { reset, change, stopSubmit } from 'redux-form';
import shopAPI from '../../_api/shop';
import { ARRANGEMENT_TYPE_SLUG } from '../../config';
import tinycontentAPI from '../../_api/tinycontent';


export const setShopCountersData = data => ({type: SET_SHOP_COUNTERS, data});
const recalculateArrangementsCount = () => ({type: RECALCULATE_ARRANGEMENTS_COUNT});
const recalculateLessonsCount = () => ({type: RECALCULATE_LESSONS_COUNT});
const recalculateModeratorArrangementsCount = () => ({type: RECALCULATE_MODERATOR_ARRANGEMENTS_COUNT});
const recalculateModeratorLessonsCount = () => ({type: RECALCULATE_MODERATOR_LESSONS_COUNT});

const setShopTags = list => ({type: SET_SHOP_TAGS, list});
const setShopComposers = list => ({type: SET_SHOP_COMPOSERS, list});
const setShopPerformers = list => ({type: SET_SHOP_PERFORMERS, list});
const setShopFilms = list => ({type: SET_SHOP_FILMS, list});
const setShopDifficulties = list => ({type: SET_SHOP_DIFFICULTIES, list});
const setShopTonalities = list => ({type: SET_SHOP_TONALITIES, list});
const setOffersFormInfo = data => ({type: SET_OFFERS_FORM_INFO, data});

const setOffersList = list => ({type: SET_OFFERS_LIST, list});

const setModerOffersList = list => ({type: SET_MODER_OFFERS_LIST, list});

const removeOffer = id => ({type: REMOVE_OFFER, id});
const pushOffer = item => ({type: CREATE_OFFER, item});

const setInitialValues = data => ({type: SET_OFFER_FOR_UPDATE, data});
const setUpdatedFiles = list => ({type: SET_UPDATED_FILES, list});
const setHideDeleteFileActions = value => ({type: SET_HIDE_DELETE_FILES_ACTIONS, value});
export const clearInitialValues = () => ({type: CLEAR_INITIAL_VALUES});
export const clearUpdatedFiles = () => ({type: CLEAR_UPDATED_FILES});
export const clearHideDeleteFileActions = () => ({type: CLEAR_HIDE_DELETE_FILES_ACTIONS});

const changeOffer = item => ({type: UPDATE_OFFER, item});
const changeOfferPartial = item => ({type: UPDATE_OFFER_PARTIAL, item});
const changeModeratorOfferPartial = item => ({type: UPDATE_MODERATOR_OFFER_PARTIAL, item});

export const clearPriceField = () => dispatch => { dispatch(change('arrangementForm', 'price', 0)) }


export const getTagsList = (category) => async (dispatch) => {
  const response = await shopAPI.getTagsList(category);
  dispatch(setShopTags(response));
  return response;
};

export const getDifficultyList = () => async (dispatch) => {
  const response = await shopAPI.getDifficultyList();
  if (response) dispatch(setShopDifficulties(response));
};

export const getTonalityList = () => async (dispatch) => {
  const response = await shopAPI.getTonalityList();
  if (response) dispatch(setShopTonalities(response));
};

export const getSystemsList = () => async (dispatch) => {
  const response = await shopAPI.getSystemsList();
  if (response) return response;
};

export const getComposersList = () => async (dispatch) => {
  const response = await shopAPI.getComposersList();
  if (response) dispatch(setShopComposers(response));
};

export const getPerformersList = () => async (dispatch) => {
  const response = await shopAPI.getPerformersList();
  if (response) dispatch(setShopPerformers(response));
};

export const getFilmsList = () => async (dispatch) => {
  const response = await shopAPI.getFilmsList();
  if (response) dispatch(setShopFilms(response));
};

export const getFormInfo = (infoName) => async (dispatch) => {
  const response = await tinycontentAPI.get(infoName);
  if (response) dispatch(setOffersFormInfo(response.content));
};

export const getOffersList = (type, moderator=false) => async (dispatch) => {
  const response = await shopAPI.getList(type, moderator);
  if (response) dispatch(setOffersList(response));
};

export const getModerOffersList = (type) => async (dispatch) => {
  const response = await shopAPI.getList(type, true);
  if (response) dispatch(setModerOffersList(response));
};

export const deleteOffer = (type, id) => async (dispatch) => {
  const response = await shopAPI.delete(type, id);
  if (response){
    dispatch(removeOffer(id));
    if (type === ARRANGEMENT_TYPE_SLUG) dispatch(recalculateArrangementsCount());
    else dispatch(recalculateLessonsCount());
  }
};

function getFormErrors(data){
  let errors = {}
  Object.entries(data).forEach(([key, value]) => {
    if (key === 'lesson'){
      Object.entries(value).forEach(([k, v]) => errors[`lesson_${k}`] = gettext(v[0]));
    } else {
      errors[key] = gettext(value[0]);
    }
  });
  return errors;
}

export const createOffer = (type, payload) => async (dispatch) => {
  const formName = type === ARRANGEMENT_TYPE_SLUG ? 'arrangementForm' : 'lessonsForm';
  const response = await shopAPI.create(type, payload);
  if (!response.error) {
    dispatch(pushOffer(response));
    dispatch(reset(formName));
    if (type === ARRANGEMENT_TYPE_SLUG) dispatch(recalculateArrangementsCount());
    else dispatch(recalculateLessonsCount());
    return response;
  } else{
    let errors = getFormErrors(response.data[0]);
    dispatch(stopSubmit(formName, errors))
  }
};

export const getOfferForUpdate = (type, id, moderator=false) => async (dispatch) => {
  try {
    const response = await shopAPI.getOffer(type, id, moderator);
    if (response) {
      let data = {}
      Object.entries(response).forEach(([key, value]) => {
        if (key === 'lesson') {
          Object.entries(value).forEach(([k, v]) => data[`lesson_${k}`] = v);
        } else {
          data[key] = value;
        }
      });
      dispatch(setInitialValues(data));
      dispatch(setUpdatedFiles(data['existing_files']));
      dispatch(setHideDeleteFileActions(data['is_buy']));
      return data;
    }
  } catch (e) {
    return { 'error': e.message }
  }
};

export const updateOffer = (type, id, payload, moderator=false) => async (dispatch) => {
  const formName = type === ARRANGEMENT_TYPE_SLUG ? 'arrangementForm' : 'lessonsForm';
  const response = await shopAPI.update(type, id, payload, moderator);
  if (!response.error) {
    dispatch(pushOffer(response));
    dispatch(reset(formName));
    if (type === ARRANGEMENT_TYPE_SLUG) dispatch(recalculateArrangementsCount());
    else dispatch(recalculateLessonsCount());
    return response;
  } else{
    let errors = getFormErrors(response[0]);
    dispatch(stopSubmit(formName, errors))
  }
};

export const uploadOfferImage = (payload, id, moderator=false) => async (dispatch) => {
  const response = await shopAPI.uploadOfferImage(payload, id);
  if (response) {
    if (moderator) dispatch(changeModeratorOfferPartial(response));
    else dispatch(changeOfferPartial(response));
  }
};
